import React from 'react';

/**
 * Given a component and classes, render the supplied raw HTML
 *
 * @param {String} component The component to render the HTML inside
 * @param {String} classes Classes to apply to the component
 * @param {String} rawHTML The HTML string to render inside the component
 *
 * @returns String
 */
export const renderHTML = (component: string, classes: string, rawHTML: string) => React.createElement(component, {className: classes, dangerouslySetInnerHTML: {__html: rawHTML}});
